var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24081 6.00821C8.35034 6.00276 8.46056 6 8.57143 6H12.4286C15.4288 6 17.9475 8.02897 18.7403 10.7781C19.4859 10.4171 20 9.65319 20 8.76923V7.76471C20 5.68552 18.3145 4 16.2353 4H11.2353C9.88282 4 8.72418 4.82989 8.24081 6.00821ZM18.9971 12.8191C18.8982 16.2018 16.2484 18.9743 12.8949 19.1933L10.3079 21.4787C8.97199 22.6588 6.875 21.7056 6.875 19.9181V19.0904C4.09534 18.5356 2 16.0712 2 13.115V12.6036C2 9.85392 3.67239 7.49677 6.05077 6.50325C6.40684 3.95843 8.59236 2 11.2353 2H16.2353C19.4191 2 22 4.58095 22 7.76471V8.76923C22 10.6788 20.7349 12.2929 18.9971 12.8191ZM11.8683 17.4242L8.98738 19.9692C8.94365 20.0079 8.875 19.9767 8.875 19.9181V18.0139C8.875 18.0003 8.87467 17.9868 8.87402 17.9735C8.86602 17.8085 8.80927 17.6563 8.71794 17.5313C8.57007 17.3288 8.33156 17.1974 8.0625 17.1974C5.81884 17.1974 4 15.3696 4 13.115V12.6036C4 10.0665 6.0467 8.00979 8.57143 8.00979H12.4286C14.9533 8.00979 17 10.0858 17 12.6229C17 15.1387 14.9704 17.1974 12.4669 17.1974C12.2465 17.1974 12.0337 17.278 11.8683 17.4242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3195c0d3ac6eebff5154540ec8ce7349.svg";
export { ForwardRef as ReactComponent };